// ResetPasswordPage.js
import React, { useState } from 'react';
import {
    Box,
    Typography,
    Button,
    TextField,
    Card,
    CardContent,
    CircularProgress,
} from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate, useSearchParams } from "react-router-dom";
import { API_URL } from "./config";

const CenteredBox = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    padding: "10px",
});

const ResetPasswordPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: '',
        email: searchParams.get('email') || '',
        token: searchParams.get('token') || ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match');
            setLoading(false);
            return;
        }

        const formDataObj = new FormData();
        formDataObj.append("action", "confirmReset");
        formDataObj.append("email", formData.email);
        formDataObj.append("token", formData.token);
        formDataObj.append("password", formData.password);
        formDataObj.append("confirmPassword", formData.confirmPassword);

        try {
            const response = await fetch(API_URL + "auth.php", {
                method: "POST",
                credentials: "include",
                body: formDataObj,
            });

            const result = await response.json();

            if (result.success) {
                setSuccess('Password reset successfully! Redirecting to login...');
                setTimeout(() => navigate('/login'), 2000);
            } else {
                setError(result.error || 'Password reset failed');
            }
        } catch (error) {
            setError('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <CenteredBox>
            <Card style={{
                width: "100%",
                maxWidth: "400px",
                padding: "2rem",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                marginTop: "20px",
                borderRadius: "20px",
            }}>
                <CardContent>
                    <Typography variant="h4" style={{
                        textAlign: "center",
                        marginBottom: "1rem",
                        color: "#4a90e2",
                        marginTop: "-30px",
                    }}>
                        Reset Password
                    </Typography>

                    <form onSubmit={handleSubmit}>
                        <TextField
                            label="New Password"
                            name="password"
                            type="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            fullWidth
                            margin="normal"
                            required
                            variant="outlined"
                        />

                        <TextField
                            label="Confirm New Password"
                            name="confirmPassword"
                            type="password"
                            value={formData.confirmPassword}
                            onChange={handleInputChange}
                            fullWidth
                            margin="normal"
                            required
                            variant="outlined"
                        />

                        {error && (
                            <Typography color="error" style={{ marginTop: '1rem' }}>
                                {error}
                            </Typography>
                        )}

                        {success && (
                            <Typography color="primary" style={{ marginTop: '1rem' }}>
                                {success}
                            </Typography>
                        )}

                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            style={{ marginTop: "1rem" }}
                            disabled={loading}
                        >
                            {loading ? <CircularProgress size={24} /> : "Reset Password"}
                        </Button>
                    </form>

                    <Typography
                        variant="body2"
                        style={{
                            textAlign: "center",
                            marginTop: "1rem",
                            color: "#666",
                        }}
                    >
                        <Button
                            onClick={() => navigate('/auth')}
                            style={{ textTransform: "none" }}
                        >
                            Back to Login
                        </Button>
                    </Typography>
                </CardContent>
            </Card>
        </CenteredBox>
    );
};

export default ResetPasswordPage;